
export const getSegmentsProject = async (projectId) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_URL}/api/segments/${projectId}`);
    const data = await res.json();
    return data;
  } catch (err) {
    console.error(err);
  }
};
